import { Link } from "react-router-dom";

import { DEFAULT_VERSION } from "@lib/content.ts";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <p className="font-mono text-[12px] uppercase tracking-widest text-subtle">
        404
      </p>
      <h1 className="mt-2 text-[24px] font-semibold tracking-tight text-ink">
        That page does not exist
      </h1>
      <p className="mt-2 max-w-md text-[14px] text-muted">
        The link may be from an older version of these docs, or the endpoint may
        have been renamed.
      </p>
      <Link
        to={`/${DEFAULT_VERSION}`}
        className="mt-5 rounded-default bg-accent px-3.5 py-2 text-[14px] font-medium text-accent-contrast transition hover:bg-accent-hover"
      >
        Go to the API reference
      </Link>
    </div>
  );
}
